function waitForChild(element, targetName, { timeout = 10000 } = {}) {
  return new Promise((resolve, reject) => {
    if (element.querySelector(targetName)) {
      resolve(element);
      return;
    }

    const observer = new MutationObserver(() => {
      if (element.querySelector(targetName)) {
        observer.disconnect();
        clearTimeout(timer);
        resolve(element);
      }
    });

    observer.observe(element, {
      subtree: true,
      childList: true
    });

    const timer = setTimeout(() => {
      observer.disconnect();
      reject(new Error(`Timed out waiting for "${targetName}"`));
    }, timeout);
  });
}
(($, Drupal) => {
  Drupal.behaviors.h5p_paragraph_image_alts = {
    attach(context, settings) {
      const containers = once('h5p_paragraph_image_alts_containers', '.h5p-content', context);
      if (containers) {
        containers.forEach((container) => {
          waitForChild(container, 'img', { timeout: 5000 })
            .then(() => {
              const imgs = container.querySelectorAll('img');
              imgs.forEach((img) => {
                if (!img.getAttribute('alt')) img.setAttribute('alt', '');
              })
            })
            .catch((err) => console.warn(err.message));
        })
      }}
  };
})(jQuery, Drupal);

